import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const voucherCodesMonitorRoutesDictionary = moduleRouteDictionaryFactory(
  'voucherCodesMonitor',
  'voucher-group',
  {
    list: 'list',
  },
);
